export var getCarouselStyles = function (_props) {
    return {
        container: {
            width: '100%'
        }
    };
};
//# sourceMappingURL=Carousel.styles.js.map